
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export default {
  name: "LanguageSelect",
  setup() {
    const i18n = useI18n();
    const { t } = i18n;

    i18n.locale.value = localStorage.getItem("lang")
      ? (localStorage.getItem("lang") as string)
      : "en";

    const locales = Object.freeze([
      {
        locale: "en",
        flag: "media/flags/united-states.png",
        name: t("English"),
        label: "En",
        isRtl: false,
      },
      {
        locale: "es",
        flag: "media/flags/spain.png",
        name: "Español",
        label: "Es",
        isRtl: false,
      },
      {
        locale: "it",
        flag: "media/flags/italy.png",
        name: "Italiano",
        label: "It",
        isRtl: false,
      },
      {
        locale: "pl",
        flag: "media/flags/poland.png",
        name: "Polski",
        label: "Pl",
        isRtl: false,
      },
      {
        locale: "he",
        flag: "media/flags/israel.png",
        name: "עִברִית",
        label: "He",
        isRtl: true,
      },
      {
        locale: "de",
        flag: "media/flags/germany.png",
        name: "Deutsch",
        label: "De",
        isRtl: false,
      },
      {
        locale: "fr",
        flag: "media/flags/france.png",
        name: "Français",
        label: "Fr",
        isRtl: false,
      },
    ]);

    const setLang = (lang) => {
      localStorage.setItem("lang", lang);
      i18n.locale.value = lang;
    };

    const checkIfCurrentLanguage = (lang) => {
      return i18n.locale.value === lang;
    };

    const currentLanguageLocale = computed(() => {
      return locales.find((lang) => lang.locale === i18n.locale.value);
    });

    return {
      setLang,
      checkIfCurrentLanguage,
      currentLanguageLocale,
      locales,
    };
  },
};
